var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrong(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C9.28235 12 12 9.27647 12 6C12 2.71765 9.27647 0 5.99412 0C2.71765 0 0 2.71765 0 6C0 9.27647 2.72353 12 6 12ZM3.92353 8.56471C3.65882 8.56471 3.44118 8.34118 3.44118 8.07059C3.44118 7.94118 3.49412 7.82353 3.58235 7.72941L5.30588 6.00588L3.58235 4.28235C3.49412 4.18824 3.44118 4.07059 3.44118 3.94118C3.44118 3.67059 3.65882 3.45882 3.92353 3.45882C4.06471 3.45882 4.17647 3.50588 4.26471 3.6L5.99412 5.32353L7.74118 3.59412C7.84118 3.49412 7.94706 3.44706 8.07647 3.44706C8.34118 3.44706 8.55882 3.66471 8.55882 3.92941C8.55882 4.06471 8.51765 4.17059 8.41765 4.27647L6.68824 6.00588L8.41176 7.72353C8.50588 7.82353 8.55294 7.93529 8.55294 8.07059C8.55294 8.34118 8.33529 8.56471 8.06471 8.56471C7.92941 8.56471 7.81176 8.50588 7.71765 8.41765L5.99412 6.69412L4.28235 8.41765C4.18824 8.51176 4.06471 8.56471 3.92353 8.56471Z",
    fill: "#C01722"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.aae65851.svg";
export { ForwardRef as ReactComponent };